export const findTemperatureRange = (number, data = []) => {
  return data.filter((el) => el.min <= number && el.max >= number);
};
